module.exports = __webpack_public_path__ + "static/img/5.cb65e2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/3/eng/5.png
// module id = Hwyi
// module chunks = 0